// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"CityFilter-b4481f2fb47f7cd6","label":"CityFilter-8fa972f60bb3d317","default":"CityFilter-365eef330544ff2f","mobile":"CityFilter-e339622a77829c8b"};